export default "__VITE_ASSET__6a4aa703__"